import styled from "styled-components"
import {useEffect,useState} from "react"
import api from '../../../../axios.js'
import Select, { SelectChangeEvent } from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';

let Container=styled.div`
	display:flex
`;



export default function ConsolasAddGame(props){
	let {juegoSelectedRedux,estado,consola,setConsola}=props;
	let [consolas, setConsolas] = useState([]);
	

	useEffect(()=>{
 		if(estado===0){

 	 			const reloadConsolas = async () => {
        			try {
          				const rpta = await api('/consola');
          				const data = rpta.data;
          				setConsolas(data);
        			} catch (error) {console.error("Error cargando consolas", error);}
    			}
    			reloadConsolas();
 		}
 	},[estado]);

	let handleChange=async(e)=>{
		setConsola(e.target.value)
	}

	return(
		<Container>
			<FormControl>
				<InputLabel id="demo-simple-select-label" error={consola==0}>consola</InputLabel>
				<Select  labelId="demo-simple-select-label" id="demo-simple-select"   label="consola" value={consola} onChange={handleChange} error={consola==0}>
					<MenuItem value={0}>Seleccionar..</MenuItem>
					{consolas.length>0?juegoSelectedRedux.Consolas.map(consola=>{
							let c=consolas.find(c=>c.id==consola).descripcion;
						return <MenuItem value={c}>{c}</MenuItem>		
					}):null}
				</Select>
			</FormControl>
		</Container>
		)



}